import andrePic from "@/public/images/artists/andre.png";
import { Artist } from "@/types/types";

export const andre = {
  id: "128",
  name: "Andre",
  image: andrePic,
  description: `Andre's voice is characterized by a robust and resonant timbre, anchored within a medium to low frequency range that lends it a commanding presence. His vocal delivery often features a balanced mix of chest and throat resonance, providing depth and warmth to his tone.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fandre-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Hip Hop", "Deep"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Low",
      },
      specific: {
        low: 53,
        high: 65,
      },
    },
  },
} as const satisfies Artist;
